import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import ChatHtmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ChatMessageReactionSelectorEmoji"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    emoji: {},
    more: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass({
            'reaction-emoji': true,
            more: _ctx.more
        }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click')))
  }, [
    (_ctx.emoji)
      ? (_openBlock(), _createBlock(ChatHtmlify, {
          key: 0,
          value: _ctx.emoji,
          emoji: ""
        }, null, 8, ["value"]))
      : (_ctx.more)
        ? (_openBlock(), _createBlock(SvgIcon, {
            key: 1,
            "icon-name": "ellipsis-h"
          }))
        : _createCommentVNode("", true)
  ], 2))
}
}

})